<template>
  <div class="recommend-travel">
    <div class="recommend-card">
      <van-image height="154"
                 radius="5"
                 fit="fill"
                 class="recommend-img"
                 :src="imageUrl" />
      <div class="recommend-tag"
           v-if="playDays !== 0">{{playDays}}日游</div>
      <div class="recommend-name">
        <span>{{name}}</span>
      </div>
    </div>
  </div>
</template>
<script>
//使用vant的懒加载
import { Image as VanImage } from 'vant';
import defaultCover from "@/assets/images/travel/cover.png";

export default {
  name: "recommend-travel",
  components: {
    VanImage
  },
  props: {
    imageUrl: {
      type: String,
      default: defaultCover
    },
    playDays: {
      type: Number,
      default: 3
    },
    name: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
    };
  },
  watch: {
  },
  methods: {

  }
};
</script>
<style lang="less">
.recommend-travel {
  @baseFontSize: 11px;
  @commonBackground: linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
  @commonTagColor: #ffffff;
  .recommend-card {
    border-radius: 5px;
    height: 154px;
    width: 100%;
    padding: 20px;
    text-align: left;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    .recommend-img {
      position: absolute;
      left: 0px;
      top: 0px;
      right: 0px;
      bottom: 0px;
    }
    .recommend-tag {
      padding: 5px;
      position: absolute;
      top: 10px;
      left: 10px;
      background: rgba(22, 22, 22, 0.5);
      border-radius: 5px;
      color: @commonTagColor;
      font-size: @baseFontSize;
    }
    .recommend-name {
      border-radius: 0 0 5px 5px;
      width: 100%;
      height: 60px;
      position: absolute;
      left: 0px;
      bottom: 0px;
      font-size: 13px;
      padding: 20px;
      font-weight: bold;
      color: @commonTagColor;
      background: @commonBackground;
    }
  }
}
</style>
